import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SelectValue } from 'antd/lib/select'

import { ApplicationState } from 'src/core/store'
import { getUsers } from 'src/core/store/ducks/users/actions'
import { Select } from 'src/components/Formik'

import { Option, SelectProps } from '../Select'

function SelectParticipant({
  formikProps,
  label = 'web.reports.parameter.participant.title',
  name,
  placeholder = 'web.reports.parameter.participant.placeholder',
  ...props
}: Omit<SelectProps, 'options'>) {
  const {
    users: { error, list, loading }
  } = useSelector((state: ApplicationState) => ({
    users: state.users
  }))
  const dispatch = useDispatch()
  const refTimeout = useRef<NodeJS.Timeout>(null)
  const [searchTerm, setSearchTerm] = useState<string>('')

  useEffect(() => {
    if (!list.length) {
      dispatch(getUsers())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const options = useMemo<Option[]>(() => {
    return (
      (!error &&
        !loading &&
        list
          .filter(({ code, first_name, last_name }) => {
            return (
              searchTerm.trim().length <= 0 ||
              `${code} ${first_name} ${last_name}}`
                .toLowerCase()
                .includes(searchTerm)
            )
          })
          .map(({ user_id, first_name, last_name }) => ({
            label: `${first_name} ${last_name}`,
            value: `${user_id}`
          }))
          .sort(({ label: a }, { label: b }) => (`${a}` > `${b}` ? 1 : -1))) ||
      []
    )
  }, [error, list, loading, searchTerm])

  function onSearch(value: string) {
    clearTimeout(refTimeout.current)
    refTimeout.current = setTimeout(() => {
      dispatch(getUsers(searchTerm))
    }, 500)
    setSearchTerm(value?.toLocaleLowerCase())
  }

  function onChange(value: SelectValue) {
    let filedValue = value
    if (value === undefined) {
      filedValue = ''
    }
    formikProps.setFieldValue(name, `${filedValue}`)
  }

  return (
    <Select
      {...props}
      dataTestId="users-list"
      filterOption={false}
      formikProps={formikProps}
      label={label}
      loading={loading}
      name={name}
      onChange={onChange}
      onSearch={onSearch}
      options={options}
      placeholder={placeholder}
      showSearch
    />
  )
}

export default SelectParticipant
